export const feedback = {
  title: 'Vote on Features!',
  subtitle: 'Share ideas, report bugs, and vote on what we build next.',
  viewRoadmap: 'See our public roadmap timeline',
  viewInTimeline: 'View in Timeline',
  newPost: 'Submit feedback',
  browse: 'Browse feedback',
  notFound: 'Feedback post not found.',
  submitError: 'Could not submit your feedback. Please try again.',
  commentError: 'Could not post your comment. Please try again.',
  statusUpdateError: 'Could not update status. Please try again.',
  roadmapUpdateError: 'Could not update roadmap settings. Please try again.',
  upvoteError: 'Could not upvote this post.',
  empty: 'No feedback posts match your filters.',
  backToList: 'Back to feedback',
  comments: 'Comments',
  commentPlaceholder: 'Add a comment...',
  postComment: 'Post comment',
  reply: 'Reply',
  cancelReply: 'Cancel',
  replyPlaceholder: 'Write a reply...',
  postReply: 'Post reply',
  noComments: 'No comments yet. Be the first to reply.',
  commentCount: '{{count}} comments',
  commentCount_one: '1 comment',
  commentCount_other: '{{count}} comments',
  upvoteButton: 'Upvote',
  upvoteCount: '{{count}} upvotes',
  upvoteCount_one: '1 upvote',
  upvoteCount_other: '{{count}} upvotes',
  authorLabel: 'by @{{username}}',
  loginToParticipate: 'Sign in and unlock your alias to vote or submit ideas.',
  loginToVote: 'Sign in and unlock your alias to vote.',
  loginToComment: 'Sign in and unlock your alias to comment.',
  loginToVoteOrComment: 'Login to an Alias to Vote or Comment',
  dailyLimitHint: 'You can submit up to 10 feedback posts per day.',
  searchPlaceholder: 'Search feedback...',
  sortLabel: 'Sort by',
  sortWithValue: 'Sort: {{value}}',
  filterCategory: 'Category',
  filterCategoryAll: 'All Types',
  filterStatus: 'Status',
  filterStatusWithValue: 'Status: {{value}}',
  filterStatusAll: 'All statuses',
  filterStatusDefault: 'Active (excl. released)',
  filterStatusCount: '{{count}} statuses',
  filterStatusNone: 'No statuses selected',
  filterStatusSelectAll: 'Select all',
  filterStatusReset: 'Reset default',
  filterStaffResponse: 'Staff response',
  filterStaffResponseAll: 'All posts',
  filterStaffResponseYes: 'Has staff/dev response',
  filterStaffResponseNo: 'No staff response',
  sortNewest: 'Newest',
  sortOldest: 'Oldest',
  sortUpvotes: 'Most upvoted',
  filterAll: 'All',
  statusLabel: 'Status',
  changeStatus: 'Change status',
  officialBadge: 'Official',
  showOnTimeline: 'Show on roadmap timeline',
  markOfficial: 'Mark as official',
  devResponse: 'Dev Response',
  staffResponse: 'Staff Response',
  opResponse: 'OP',
  commentFilterAll: 'All comments',
  commentFilterOp: 'OP only',
  commentFilterStaff: 'Staff/dev only',
  commentSortOldest: 'Oldest first',
  commentSortNewest: 'Newest first',
  noFilteredComments: 'No comments match this filter.',
  linkPost: 'Mark this post as related to another',
  linkPostModalTitle: 'Link to another post',
  linkPostSearch: 'Search by title...',
  linkPostSelectType: 'How are these posts related?',
  linkPostConfirm: 'Link posts',
  linkPostNoResults: 'No matching posts found.',
  linkPostError: 'Could not link these posts. Please try again.',
  relatedPostsHeader: 'May be related to {{count}} other posts',
  relatedPostsHeader_one: 'May be related to 1 other post',
  relatedPostsHeader_other: 'May be related to {{count}} other posts',
  relatedSuggestedBy: 'suggested by @{{username}}',
  linkTypes: {
    duplicate: 'Is a duplicate of',
    related: 'Seems related to',
    complementary: 'Would go well with',
  },
  linkPostSummary: {
    duplicate: "You think the current post is a duplicate of '{{title}}'?",
    related: "You think the current post seems related to '{{title}}'?",
    complementary: "You think the current post would go well with '{{title}}'?",
  },
  relatedByLabel: {
    duplicate: 'marked as duplicate',
    related: 'marked as related',
    complementary: 'would go well with this',
  },
  reciprocalByLabel: {
    duplicate: 'is a duplicate of this post',
    related: 'seems related to this post',
    complementary: 'would go well with this post',
  },
  linkCommentReciprocalSuggested: ' suggested ',
  linkCommentBodySuffix: 'suggested this post {{linkDescription}}',
  categories: {
    feature: 'New feature',
    improvement: 'Improvement',
    bug: 'Bug',
    other: 'Other',
  },
  statuses: {
    submitted: 'Submitted',
    planned: 'Planned',
    roadmapped: 'Roadmapped',
    in_progress: 'In Progress',
    internal_testing: 'Internal Testing',
    public_testing: 'Public Testing',
    released: 'Released',
    closed: 'Closed',
  },
  form: {
    title: 'Title',
    titlePlaceholder: 'Brief summary of your idea or issue',
    description: 'Description',
    descriptionPlaceholder: 'Describe your idea, bug, or suggestion in detail',
    optional: '(optional)',
    category: 'Category',
    categoryPlaceholder: 'Select a category',
    attachments: 'Attachments',
    attachmentsHint: 'Up to 3 images (JPEG, PNG, WebP, GIF). All attachments are moderated.',
    addAttachment: 'Add image',
    removeAttachment: 'Remove attachment',
    submit: 'Review and submit',
    charsRemaining: '{{count}} characters remaining',
    addToTimeline: 'Add to timeline',
    addToTimelineHint: 'Show this entry on the public roadmap timeline. Optionally set a target release date.',
    targetReleaseDate: 'Target release date',
    roadmapOfficial: 'Official',
    roadmapOfficialHint: 'Tag this as an official team entry (shown in the feature list). Does not affect timeline visibility.',
    initialStatus: 'Initial status',
    initialStatusPlaceholder: 'Select a status (optional)',
  },
  confirm: {
    title: 'Confirm submission',
    description: 'Before posting, please confirm the following:',
    publicVisible: 'I understand my post will be publicly visible to other users.',
    legalAgreement:
      'I agree to the <tosLink>Terms of Service</tosLink>.',
    submit: 'Submit feedback',
  },
  notifications: {
    prefsTitle: 'Notification preferences',
    notifyPostReplies: 'Notify me of replies to my posts',
    notifyCommentReplies: 'Notify me of responses to my comments',
    postReply: 'New reply on your feedback post',
    commentReply: 'New reply to your comment',
    replyBody: '{{username}} replied on "{{title}}"',
  },
} as const;
